module.exports = __webpack_public_path__ + "img/metamask.07dd01ed.svg";